import { render, staticRenderFns } from "./PagesOfRegistration.vue?vue&type=template&id=cbfbba1c&scoped=true"
import script from "./PagesOfRegistration.vue?vue&type=script&lang=js"
export * from "./PagesOfRegistration.vue?vue&type=script&lang=js"
import style0 from "./PagesOfRegistration.vue?vue&type=style&index=0&id=cbfbba1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbfbba1c",
  null
  
)

export default component.exports